<template lang="pug">



    form.ui.form(v-on:submit.prevent='submit()')

        .ui.icon.info.message(v-if='!isLocked')
            i.info.icon
            .content
                p: strong Angebot bitte bis zum {{ validUntilDate }} um {{ validUntilTime }} Uhr abgeben.
                | Es werden nur die Preise gespeichert, die Herstellungs- und Versandkosten enthalten.
                br
                | Eine Änderung ist nach der Speicherung nicht mehr möglich.

        table.ui.form.small.striped.compact.table

            thead
                tr
                    th.one.wide Auflage
                    th.three.wide Herstellungskosten in €
                    th.three.wide Stückpreis in €
                    th.three.wide Versand in €
                    th.two.wide Summe
                    th.four.wide Kommentar
            tbody
                //- <!--suppress JSUnusedLocalSymbols -->
                tr(
                    is="row"
                    v-for="(priceModel, index) in models.prices"
                    v-bind:key='index'
                    v-bind:disabled='isLocked'
                    v-on:input='updatePrice($event, index)'
                    v-bind:value='models.prices[index]'
                )


            tfoot(v-if='!isLocked')
                tr
                    th(colspan='3')
                        button.ui.small.negative.right.labeled.icon.button(type='button' v-on:click="decline()")
                            i.remove.icon
                            | Kein Angebot zu dieser Variante abgeben
                    th.right.aligned(colspan='6')
                        button.ui.small.primary.labeled.icon.button(type='submit')
                            i.checkmark.icon
                            | Angebot speichern
            tfoot
                tr
                    th(colspan='6')
                        .two.fields

                            //- Angebotsnummer
                            text-field(label='Angebotsnummer' v-model='models.offer.number' v-bind:disabled='isLocked')


                            //- Angebot gültig bis
                            date-field(
                                label='Angebot gültig bis'
                                v-bind:isRequired='true'
                                v-bind:disabled='isLocked'
                                v-model='models.offer.validUntilBySupplier'
                            )
                                field-error(v-bind:validation='validation' attribute='models.offer.validUntilBySupplier')

</template>

<script>
    import * as R from 'ramda'
    import { to_ddmmyyyy, to_hhmm } from "@/utils/date"
    import { Validator } from 'simple-vue-validator'
    import Row from './price-table/Row'
    import DateField from '@/components/form/DateField'
    import TextField from '@/components/form/TextField'
    import FieldError from '@/components/form/SmartFieldError'

    //noinspection JSUnusedGlobalSymbols
    export default {

        components: { DateField, FieldError, Row, TextField },

        computed: {

            isLocked() {
                return this.models.offer.status !== 'OPEN'
            },

            validUntilDate() {
                return to_ddmmyyyy(this.jobModel.validUntil)
            },

            validUntilTime() {
                return to_hhmm(this.jobModel.validUntil)
            }

        },

        created() {
            this.refreshModels()
        },

        data() {
            return {
                models: {
                    offer: {},
                    prices: []
                }
            }
        },

        methods: {

            refreshModels() {
                this.models.offer = R.clone(this.offerModel)
                this.models.prices = R.clone(this.priceModels)
            },

            async decline() {
                if (!await this.$growl.confirm('Soll diese Anfrage abgelehnt werden? Diese Entscheidung kann nicht rückgängig gemacht werden.')) {
                    return
                }

                const model = R.assoc('status', 'DECLINED', this.models.offer)

                // Speichern
                this.$store.dispatch('offers/update', { model })

                    // Erfolgssmeldung anzeigen
                    .then(() => this.$growl.success('Zur Variante wurde kein Angebot abgegeben'))

                    // ggf. Fehlermeldung
                    .catch(e => this.$growl.fatal('Status von Angebot konnte nicht auf `DECLINED` gesetzt werden', e))
            },

            persistOffer() {
                const model = R.assoc('status', 'PENDING', this.models.offer)

                // Angebot speichern
                return this.$store.dispatch('offers/update', { model })

                    // Erfolgsmeldung anzeigen
                    .then(() => this.$growl.success('Angebot wurde gespeichert'))

                    // ggf. Fehlermeldung anzeigen
                    .catch(e => this.$growl.fatal('Angebot konnte nicht gespeichert werden', e))
            },

            async persistPrices() {
                return await R.compose(

                    promises => Promise.all(promises),

                    R.map(model => this.$store.dispatch('prices/patch', { id: model.id, patch: model })),

                )(this.models.prices)
            },

            async submit() {
                // Validierung durchführen
                if (!await this.$validate()) {
                    return
                }

                // Bestätigung einholen
                if (!await this.$growl.confirm('Soll dieses Angebot gespeichert werden? Eine Änderung ist danach nicht mehr möglich.')) {
                    return
                }

                // Angebot und Preise speichern
                try {
                    await Promise.all([
                        this.persistOffer(),
                        this.persistPrices()
                    ])
                } catch (e) {
                    // ggf. Fehler anzeigen
                    this.$growl.fatal('Fehler beim Speichern von Preisen aufgetreten', e)
                }
            },

            updateOffer(property, value) {
                this.models.offer = R.assoc(property, value, this.models.offer)
            },

            updatePrice(price, index) {
                this.models.prices = R.update(index, price, this.models.prices)
            },

        },

        props: {

            jobModel: {
                type: Object,
                required: true,
            },

            offerModel: {
                type: Object,
                required: true,
            },

            priceModels: {
                type: Array,
                required: true,
            }

        },

        validators: {

            'models.offer.validUntilBySupplier'(value) {
                return Validator.value(R.defaultTo('', value))
                    .required('Darf nicht leer sein. Bitte eine Angebotsgültigkeit angeben')
            }

        },

        watch: {

            offerModel() {
                this.refreshModels()
            },

            priceModels() {
                this.refreshModels()
            }

        }

    }


</script>
